<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import FouContainer from 'components/tools/fou-container/'
import { mapGetters } from 'vuex'
import { getEmailVerifiedFromLocalStorage } from 'src/utils/helper/localStorage'
export default {
  name: 'Stepper',
  components: {
    FouContainer
  },
  props: {
    stepsTitle: {
      type: Array
    },
    keepAlive: {
      type: Boolean,
      default: false
      },
      siblingStepData: {
        type: Array,
        default: null
      },
  },
  data () {
    return {
      steps: [],
      activeStep: 0
    }
  },
  computed: {
    dynamicStepperWidth () {
      return (100 / this.stepsTitle.length) + '%'
    },
    ...mapGetters('signUp', {
      isReview: ['getReviewPage']
    })
  },
  created () {
    this.setStepperComponents()
    this.$events?.$on('next-step', (index) => {
      this.executeNext(index)
      this.refreshEmailVerificationStatus()
    })
    this.$events?.$on('back-step', (index) => {
      this.activeStep = index - 1
      this.refreshEmailVerificationStatus()
    })
    this.$events?.$on('redirect-step', (index) => {
      this.activeStep = index - 3
      if (this.isReview) {
        this.steps[0].completed = false
        this.steps[1].completed = false
        this.steps[2].completed = false
      }
      this.refreshEmailVerificationStatus()
    })
    if (this.isReview) {
      this.steps[2].completed = true
      this.steps[1].completed = true
      this.steps[0].completed = true
      this.activeStep = 3
    }
  },
  beforeUnmount () {
    this.$events.$off('next-step')
    this.$events.$off('back-step')
    this.$events.$off('redirect-step')
  },
  methods: {
    setStepperComponents () {
      if (this.stepsTitle.length > 0) {
        this.steps = this.stepsTitle.map((obj, id) => {
          if (id === 0) {
            return { ...obj, completed: false, currentStep: true, idx: id }
          }
          return { ...obj, completed: false, currentStep: false, idx: id }
        })
      }
    },
    executeNext (index) {
      if (this.steps.length - 1 === index) {
        this.steps[index].completed = true
        this.activeStep = index
      } else {
        this.steps[index].completed = true
        this.activeStep = index + 1
      }
    },
    refreshEmailVerificationStatus () {
      if (
        this.$store.getters['auth/isUserAuthenticated'] &&
        !getEmailVerifiedFromLocalStorage()
      ) {
        this.$store.dispatch('auth/getUserDetails')
      }
    }
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
